import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { purchaseNotices } from '../data/purchaseNotifications';
const FIRST_DELAY = 6000;
const VISIBLE_MS = 6000;
const GAP_MS = 11000;
export function PurchaseNotifications() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), FIRST_DELAY);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (dismissed || !visible) return;
    const hide = window.setTimeout(() => setVisible(false), VISIBLE_MS);
    return () => window.clearTimeout(hide);
  }, [visible, dismissed]);
  useEffect(() => {
    if (dismissed || visible) return;
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % purchaseNotices.length);
      setVisible(true);
    }, GAP_MS);
    return () => window.clearTimeout(next);
  }, [visible, dismissed]);
  const notice = purchaseNotices[index];
  return <div aria-live="polite" className="pointer-events-none fixed bottom-24 left-4 z-50 max-w-[calc(100vw-2rem)] sm:bottom-28 sm:left-6" data-id="element-110" data-mp="jva3eppvgjqp">
      <AnimatePresence data-id="element-111" data-mp="1cj5u9dsrfhfk">
        {visible && !dismissed && <motion.div key={`${notice.name}-${index}`} initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 12,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-center gap-3 border border-line bg-surface py-3 pl-3 pr-2 shadow-2xl shadow-black/50" data-id="element-112" data-mp="1cied37zwtm8t">
            <span className="flex h-8 w-8 shrink-0 items-center justify-center bg-volt" data-id="element-113" data-mp="3jbq5dxh82gg6">
              <CheckIcon className="h-4 w-4 text-ink" aria-hidden="true" data-id="element-114" data-mp="3krklbpyh7te2" />
            </span>
            <div className="min-w-0" data-id="element-115" data-mp="3pp47rd5bvch3">
              <p className="font-sans text-sm font-semibold leading-tight text-white" data-id="element-116" data-mp="3asva2g13576s">
                {notice.name} from {notice.location} just bought the Blueprint
              </p>
              <p className="mt-0.5 font-sans text-[11px] uppercase tracking-[0.14em] text-muted" data-id="element-117" data-mp="3ftix6qm713vq">
                {notice.timeAgo} • Verified purchase
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss purchase notifications" className="shrink-0 self-start p-1 text-muted transition-colors duration-150 ease-swift hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-volt" data-id="element-118" data-mp="36t4e7xwpc0ve">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-119" data-mp="2n5514geo0hmt" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}